(function(e) {
  History.Adapter.bind(window,'statechange',function() {
    if (e(".product-listing").length > 0 || e(".filters-row").length > 0) {
      if(!obj.ajaxClickHandlerState) {
        const n = location.search == "" ? "" : `"?"${location.search}`;
        const url = `${location.pathname} ${n}`;
        obj.getCollectionContent(url);
      }
      obj.ajaxClickHandlerState = false;
    }
  });

  let queryParams = {};
  let obj = {
    init: function() {
      queryParams = this.getQueryParams();
      this.initSidebar();
      this.initToolbar();
      this.initShowMore();
      this.initApplyFiltres();
    },
    initSidebar: function() {
      obj.initFiltresEvent();
      obj.initFiltresEventOnchange();
      obj.initFiltresRemoveEvent();
      obj.initFiltresRemoveEventOnchange();
    },
    initToolbar: function() {
      obj.initSortbyState();
      obj.initSortbyStateOnchange();
      obj.initSortbyEvent();
      obj.initSortbyEventOnchange();
      obj.initPerpageEvent();
      obj.initPaginationEvent();
    },
    initShowMore: function() {
      obj.initShowMoreEvent();
    },
    initShowMoreEvent: function() {
      if (e(".show-more a").length > 0) {
        e(".show-more a").click(function(event) {
          if (!e(this).hasClass("disable")) {
            obj.showMoreHandler();
          }
          event.preventDefault();
        })
      }
    },
    initApplyFiltres: function(){
      if (e(".apply-filter").length > 0) {
        e('.apply-filter').click(function(){
          event.preventDefault();
          obj.initFiltresEvent();
          e('.icon-close').click();
        })
      }
    },
    showMoreHandler: function() {
      const scrollURL = e('.show-more a').last().attr("href");
      e.ajax({
        type: "GET",
        url: scrollURL,
        dataType: "html",
        beforeSend: function() {
          obj.showPreloader();
        },
        success: function(data) {
          obj.hidePreloader();
          if (e(data).find(".show-more a").length > 0) {
            e(".show-more").replaceWith(e(data).find(".show-more"));
            if(e(".show-more a").attr('href')) {
              obj.initShowMoreEvent();
            }
          } else {
            if(e(".show-more a").length > 0) {
              e(".show-more a").remove();
            }
          }

          if (e(data).find(".product-listing").length > 0) {
            e(data).find(".product-listing > div").each(function() {
              e('.product-listing').append(e(this));
            });

            $('body').trigger('refreshCurrency');
            if(e(".spr-badge").length > 0) {
              e.getScript(`"${window.location.protocol}//productreviews.shopifycdn.com/assets/v4/spr.js"`);
            }
          }
          data = null;
        },
      })
    },
    initFiltresEvent: function() {
      if (e(".filtres-js").length > 0) {
        e('.filtres-js:not(.clear-filters) a').unbind().click(function(event) {
          event.preventDefault();
          delete queryParams.page;
          const $_this = e(this);
          const tag = $_this.attr('href').split('/').pop().split('?').shift();
          const constraint = queryParams.constraint;
          queryParams.constraint = constraint ? `${constraint}+${tag}` : tag;
          obj.ajaxClick(obj.getAjaxLink(queryParams));
        });
      }
    },
    initFiltresEventOnchange: function() {
      const filter_for = $('.filter_For').find('li');
      if(filter_for.length == 1) {
        filter_for.find('input').prop( "checked", true );
        filter_for.css("pointer-events", "none");
      }
      if (e(".filtres-js").length > 0) {
        const filters_clear = e('.filtres-js:not(.clear-filters) .chck');
        filters_clear.unbind().click(function(event) {
          delete queryParams.page;
          const $_this = e(this);
          const tag = $_this.attr('tagnew').replace("/","\/").replace(' ','-');
          const constraint = queryParams.constraint;
          queryParams.constraint = constraint ? `${constraint}+${tag}` : tag;
          obj.ajaxClick(obj.getAjaxLink(queryParams));
          $_this.prop('checked', true);
        });
        filters_clear.keydown(function(event) {
          if(event.keyCode == 13){
            $(this).click();
          }
        });
      }
    },
    initFiltresRemoveEvent: function() {
      const filters_js = e(".filtres-remove-js");
      if (filters_js.length > 0) {
        const filtres_remove =  e('.filtres-remove-js a');
        filtres_remove.unbind().click(function(event) {
          event.preventDefault();
          delete queryParams.page;
          const $_this = e(this);
          if($_this.hasClass('clear_all')) {
            delete queryParams.constraint;
          } else {
            const href = $_this.attr('href');
            const path = location.pathname;
            const page = obj.getUrlSubcategory('/collections/', path);
            const tag = href.split(page).pop().split('/').pop();
            tag != '' ? queryParams.constraint = tag : delete queryParams.constraint;
          }
          obj.ajaxClick(obj.getAjaxLink(queryParams));
        });

        filtres_remove.keydown(function(event) {
          if(event.keyCode == 13) {
            $(this).click();
          }
        });
      }
    },
    initFiltresRemoveEventOnchange: function() {
      const filters_js = e(".filtres-js .chck:checked");
      if (filters_js.length > 0) {
        filters_js.unbind().click(function(event) {
          event.preventDefault();
          delete queryParams.page;
          const $_this = e(this);

          if($_this.prop("checked",true)) {
            $_this.prop("checked",false);
            let temp = $_this.attr("tagold");
            const tempremove = $_this.attr("tagnew").replace("/","\/").replace(" ","-");
            temp = jQuery(temp);
            let href = temp.attr('href');
            href = href.split('?');
            href.includes("?view=ajax") ? href = href.replace("?view=ajax","") : href =  href;
            const path = location.pathname;
            const page = obj.getUrlSubcategory('/collections/', path);
            let tag = href[0].split(path).pop().split('/').pop();
            tag = tag.split('+');
            tag = tag.filter(function(x){if(x != tempremove){return x}});
            tag = tag.toLocaleString().replace(/,/g,'+');
            tag.split('?') != undefined ? tag = tag.replace('?view=ajax','') : tag = tag;
            tag != '' ? queryParams.constraint = tag : delete queryParams.constraint;
          } else {
            delete queryParams.constraint;
          }
          obj.ajaxClick(obj.getAjaxLink(queryParams));
        });
      }
    },
    initSortbyState: function() {
      if (e(".sort-position").length > 0) {
        if (queryParams.sort_by) {
          sortbychange();
        }
      }
    },
    initSortbyStateOnchange: function() {
      if (queryParams.sort_by) {
        sortbychange();
      }
    },
    initSortbyEvent: function() {
      const sort_position = e(".sort-position");
      if (sort_position.length > 0) {
        sort_position.change(function(event) {
          const val = e(this).val();
          queryParams.sort_by = val;
          obj.ajaxClick(obj.getAjaxLink(queryParams));
        });
      }
    },
    initSortbyEventOnchange: function() {
      let currentElement = "";
      const sort_by = $(".sort_by1");
      sort_by.children('li').on('click keypress',function(e) {
        currentElement = $(this);
        if(currentElement === "" || currentElement === undefined) {
          currentElement =  sort_by.children('li').first();
        }
        $("#sort_by1 li").removeClass('active');
        $(this).addClass('active');
        const opt_name =  currentElement.attr('value');
        queryParams.sort_by = opt_name;
        const btn_value =  currentElement.text();
        sort_by.siblings('.btn').text(btn_value);
        obj.ajaxClick(obj.getAjaxLink(queryParams));
      });
    },
    initPerpageEvent: function () {
      const show_qty = e(".show-qty");
      if (show_qty.length > 0) {
        show_qty.change(function(event) {
          const val = e(this).val();
          if(e(this).find('option:selected').index() === 0) {
            delete queryParams.view;
          } else {
            queryParams.view = val;
          }
          delete queryParams.page;
          obj.ajaxClick(obj.getAjaxLink(queryParams));
        });
      }
    },
    initPaginationEvent: function() {
      if (e(".pagination").length > 0) {
        e(".pagination a").unbind().click(function(event) {
          event.preventDefault();
          if(!e(this).parent().hasClass("active")) {
            const value = e(this).attr("href").match(/page=\d+/g);
            if (!value) return false;
            queryParams.page = parseInt(value[0].match(/\d+/g), 10);
            obj.ajaxClick(obj.getAjaxLink(queryParams));
            const current_class = ".product-listing";
            const stuck = e('.stuck').length ? e('.stuck').height() : 0;
            const top = e(current_class).offset().top - stuck;
            e(window).scrollTop(top);
          }
        });
      }
    },    
    getAjaxLink: function(value) {
      const page = obj.getUrlSubcategory('/collections/', location.pathname);
      const pathname = `/collections/${page}`;
      value = obj.getDecodedUrl(value);      
      return value != "" ? `${pathname}?${value}` : pathname;
    },
    //AJAX
    ajaxClick: function(url) {
      obj.ajaxClickHandlerState = true;
      History.pushState({
        param: Shopify.queryParams
      }, document.title, url);
      obj.getCollectionContent(url);
    },
    getCollectionContent: function(url) {
      let view = url.match(/view=([^&#]*)/);
      if (!view) {
        url += `${String(url.indexOf('?') > -1 ?'&':'?')}view=ajax`;
      } else {
        view = view[0];
        url = url.replace(view, `${view}ajax`);
      }
      const params = {
        type: "get",
        url: url,
        beforeSend: function() {
          obj.showPreloader();
        },
        success: function(data) {
          obj.hidePreloader();
          obj.pageData(data);
          obj.initPaginationEvent();
          obj.initSidebar();
          obj.initShowMore();
        },
      }
      jQuery.ajax(params);
    },
    //Get and show new content
    pageData: function(data) {
      let current_class = ".product-listing";
      let content = e(data).find(current_class);
      e(current_class).empty();
      e(current_class).append(content.html());

      current_class = ".filtres-js";
      e(current_class).each(function(index) {
        const $_this = e(this);
        const $_parent_group = $_this.closest('.collapse-block');
        content = e(data).find(`${current_class}:eq(${index})`);
        $_this.replaceWith(content);
        content = e(data).find(`${current_class}:eq(${index})`).closest('.collapse-block');
        content.hasClass('hide') ? $_parent_group.addClass('hide') : $_parent_group.removeClass('hide');
      });

      content = e(data).find(".product-pagintion");
      content.length && e.type(content.html()) === "undefined" ? e(".product-pagintion").empty() : e(".product-pagintion").replaceWith(content);

      content = e(data).find(".number-of-products");
      e(".number-of-products").replaceWith(content);

      content = e(data).find(".collected-products");
      e(".collected-products").replaceWith(content);

      content = e(data).find('.infinitybutton');
      e('.infinitybutton').replaceWith(content);

      $('body').trigger('refreshCurrency');
      if(e(".spr-badge").length > 0) {
        e.getScript(`"${window.location.protocol}//productreviews.shopifycdn.com/assets/v4/spr.js"`);
      }
      content = null;
      data = null;
    },    
    showPreloader: function() {
      e(".custom-loader").show();
    },

    hidePreloader: function() {
      e(".custom-loader").hide();
    },    
    getUrlSubcategory: function (category, url) {
      let str = url;
      const n = str.indexOf(category);
      if(n < 0)
        return "";
      str = str.slice(n + category.length, str.length);
      const m = str.indexOf("/") > -1 ? str.indexOf("/") : str.length;
      str = str.slice(0, m).toLowerCase();
      return str.replace(`${name}=`, "", "");
    },    
    getQueryParams: function() {
      const location_path = location.pathname;
      const location_search = location.search;
      let path_search = location_path.split('/');
      const search_pop = path_search.pop().replace(/&/g, "");
      path_search.length > 3 ? path_search = `constraint=${search_pop}` : path_search = location_search.split('?').pop();
      if(path_search === '') return {};
      else return obj.uriToJson(path_search);
    },
    uriToJson: function (value) {
      return JSON.parse('{"' + decodeURI(value.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
    },
    getDecodedUrl: function(value) {
      return decodeURIComponent($.param(value));
    }
  }

  function sortbychange() {
    const qry_param = queryParams.sort_by;
    const text_value = $(`[value="${qry_param}"]`)[0].innerHTML;

    $(".sort_by1").siblings('.btn').text(text_value);
    e('.sort-position').each(function() {
      e(this).val(queryParams.sort_by);
    }); 
  }

  e(document).ready(function() {
    obj.init();
    function setDefaultText() {
      const defaultSelectText = $(".leftColumn .custom-dropdown-select ul li.active").find('a').text();
      $(".leftColumn .custom-dropdown-select button").text(defaultSelectText);
    }

    function setCollectionText() {
      const defaultCollectionText = $(".mobile-collection-filter .custom-dropdown-select ul li.active").find('a').text();
      $(".mobile-collection-filter .custom-dropdown-select button").text(defaultCollectionText);
    }
    setDefaultText();

    const leftcolumn_filter = $(".leftColumn .custom-dropdown-select ul li");
    leftcolumn_filter.on('click', function(){
      leftcolumn_filter.removeClass('active');
      $(this).addClass('active');
      setDefaultText();
    })
    setCollectionText();

    const mobile_filter = $(".mobile-collection-filter .custom-dropdown-select ul li");
    mobile_filter.on('click', function() {
      mobile_filter.removeClass('active');
      $(this).addClass('active');
      setCollectionText();
    })
  });
})(jQuery)

/*  Filter Keyboard accessbillity   */
function filterFocus() {
  const focusableElements = '.slide-column-close .close-btn, .leftColumn button, .leftColumn a, .leftColumn input, .leftColumn select, .leftColumn textarea, .collection-sort-dropdown .dropdown-toggle, .collection-sort-dropdown .sort-position li';
  const filterModal = document.querySelector('.container-wrap-collection');
  const firstFocusableElement = filterModal.querySelectorAll(focusableElements)[0];
  const focusableContent = filterModal.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent[focusableContent.length - 1];

  console.log("focusableElements", focusableContent);
  document.addEventListener('keydown', function(e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) return 
  
    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) { 
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  });
  firstFocusableElement.focus();
}
setTimeout(function() {
  if ($(window).width() < 1025) {
    document.querySelector('.slide-column-open').addEventListener('click', function() {
      filterFocus();
    });
    document.querySelector('.slide-column-close .close-btn').addEventListener('click', function() {
      document.querySelector('.slide-column-open').focus();
    });
  }
}, 2000);


